import styles from './InstallationSection.module.css';
import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import NumberAndData from '../../components/NumberAndData/NumberAndData';
import { HiMiniDocumentText } from 'react-icons/hi2';
import { NavLink } from 'react-router';

export const InstallationSection = () => {
  const installationData = {
    heading: 'Installations',
    icon: <HiMiniDocumentText />,
    numbers: [
      {
        number: 5,
        label: 'By Parents',
        bgColor: 'rgba(from var(--Primary_Color) r g b / 0.35)',
      },
      {
        number: 0,
        label: 'By Staff',
        bgColor: 'rgba(from var(--Error_Color) r g b / 0.4)',
      },
    ],

    registrations: [28, 25],
    installations: [10, 20],
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <HeadingAndIcon
          icon={installationData.icon}
          heading={installationData.heading}
        />
        <NavLink className={styles.viewAll} to={'reports/parentreports'}>
          View All
        </NavLink>
      </div>

      <div className={styles.topRow}>
        {installationData.numbers.map((item, i) => (
          <NumberAndData
            key={i}
            number={item.number}
            label={item.label}
            backgroundVar={item.bgColor}
          />
        ))}
      </div>

      <div className={styles.chart}>
        {installationData.registrations.map((total, i) => {
          const install = installationData.installations[i];
          const height = (install / total) * 100;

          return (
            <div className={styles.barContainer} key={i}>
              <div className={styles.totalLabel}>{total}</div>
              <div className={styles.barWrapper}>
                <div className={styles.totalBar}>
                  <div
                    className={styles.installedBar}
                    style={{ height: `${height}%` }}
                  >
                    {install}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className={styles.legend}>
        <div className={styles.dotRow}>
          <span className={styles.lightDot}></span>
          <span>Total Registrations</span>
        </div>
        <div className={styles.dotRow}>
          <span className={styles.solidDot}></span>
          <span>Total Installations</span>
        </div>
      </div>
    </div>
  );
};

export default InstallationSection;
